import { CheckCircle2Icon } from "lucide-react";
import React from "react";

export default function CopyStep12() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 ">
          <CheckCircle2Icon className="w-8 h-8 text-green-500" />
        </div>
        <h1>
          <b>PRONTO!</b> A estratégia automatizada da MAIA™ já está ativada em
          sua conta!
        </h1>
      </div>
      <div className="ml-[42px] flex flex-col gap-1.5">
        <p>
          Agora basta acompanhar o andamento das operações e realizar novos
          depósitos ou saques quando quiser.
        </p>
        <p>
          Você pode sempre acompanhar tudo em tempo real clicando na opção "Copy
          Trade" no menu do app da XM.
        </p>
        <p>
          E claro, em nosso canal oficial do Telegram e também na plataforma da
          Money Academy, você também receberá alertas e insights sobre o mercado
          e resultados da MAIA™.
        </p>
      </div>
    </div>
  );
}
